import Pikaday from 'pikaday';

class SelectorFechaDirective {

    constructor(fechaConfig, $timeout, utilFactory) {

        this.fechaConfig = fechaConfig;
        this.$timeout = $timeout;
        this.utilFactory = utilFactory;
        this.require='ngModel';
        this.scope= {
            minDate: "=",
            maxDate: "="
        };
    }

    link(scope, elem, attrs, ngModel) {

        const picker = new Pikaday({
            field: elem[0],
            minDate: scope.minDate,
            maxDate: scope.maxDate,
            firstDay: 1,
            format: this.fechaConfig.FORMATO_FECHA.toUpperCase(),
            i18n: {
                previousMonth: 'Siguiente',
                nextMonth: 'Anterior',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                weekdaysShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
            },
            onSelect:  (date) => {
                scope.$parent.$apply();
            }
        });

        let setPickerDate =  (event) => {
            if (event && event.type == "keyup" && event.which != 13) return;
            if (!ngModel.$modelValue) return;

            if (typeof ngModel.$modelValue == "string") {
                picker.setDate(this.utilFactory.convertirFecha(ngModel.$modelValue));
            } else {
                picker.setDate(ngModel.$modelValue);
            }
        };

        scope.$watch('minDate', function () {
            if (!scope.minDate) return;
            picker.setMinDate(scope.minDate);
        });

        scope.$watch('maxDate', function () {
            if (!scope.maxDate) return;
            picker.setMaxDate(scope.maxDate);
        });

        this.$timeout(setPickerDate);

        elem.on("blur", setPickerDate);
        elem.on("keyup", setPickerDate);
    }
}


SelectorFechaDirective.$inject = ['fechaConfig', '$timeout','utilFactory'];

export default SelectorFechaDirective;


// WEBPACK FOOTER //
// ./src/busqueda/directivas/selector-fecha.directive.js